/**
 *	shop-services.directive.js
 */

import shopServicesTpl from './shop-services.tpl.html!text';
import ShopServicesCtrl from './shop-services.ctrl.js';

var shopServicesDirective = function() {
 	return {
 		restrict: 'E',
 		replace: true,
 		transclude: true,
 		scope: {},
 		template: shopServicesTpl,
 		controller: ShopServicesCtrl,
 		controllerAs: 'ctrl',
 		bindToController: {
 			serviceTypes: '=',
 			paymentTypes: '=',
 			moneyTransferOptions: '='
 		},
 	};
 };

 export default shopServicesDirective;